var render = function render(){var _vm=this,_c=_vm._self._c;return _c('date-picker',{staticClass:"w-100",attrs:{"range":"","placeholder":"Data Inicial  Data Final","format":"DD MMM YYYY","lang":_vm.lang},on:{"clear":_vm.callClear},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})
}
var staticRenderFns = []

export { render, staticRenderFns }